import React from 'react'

type Props = {
  title?: string
  type?: 'text' | 'password' | 'email'
  onChange?: (event: React.ChangeEvent<HTMLInputElement>) => any
  error?: string
  defaultValue?: string
}

const AuthorizationInputs = (props: Props) => {
  const { title, type, onChange, error, defaultValue } = props
  return (
    <div className="Authorization-card-form-inputs">
      <h4 className="Authorization-card-form-inputs-title">{title}</h4>
      <input
        onChange={onChange}
        className={`Authorization-card-form-inputs-input ${
          error ? 'error' : ''
        }`}
        type={type}
        defaultValue={defaultValue}
      />
      {error ? (
        <span className="Authorization-card-form-inputs-helperText">
          {error}
        </span>
      ) : null}
    </div>
  )
}

export default AuthorizationInputs
